import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    TemplateRef,
    ViewChild,
  } from '@angular/core';

  @Component({
    selector: 'ce-popover-overlay',
    templateUrl: './ce-popover-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush, 
    exportAs: 'cePopoverOverlay',  
    standalone: true,
  })

  export class CePopoverOverlayComponent  {  
    @ViewChild(TemplateRef) templateRef!: TemplateRef<ElementRef>;
  }